import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgUae = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "b",
      width: 24,
      height: 25,
      x: 0,
      y: 0,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M24 .5H0v24h24z"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M8 16.5h15.314c.443-1.251.686-2.597.686-4s-.243-2.749-.686-4H8z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#1E5B00",
        d: "M8 8.5h15.314C21.668 3.84 17.224.5 12 .5c-1.403 0-2.749.243-4 .685z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.314 16.5H8v7.314a12 12 0 0 0 4 .686c5.224 0 9.667-3.34 11.314-8"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F0263C",
        d: "M8 23.814V1.186C3.34 2.833 0 7.276 0 12.5s3.34 9.667 8 11.314"
      })]
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 .5h24v24H0z"
      })
    })
  })]
});
export default SvgUae;